<template>
  <div>
    <div class="bg">
      <el-card :body-style="{ padding: '0px' }">
        <div class="content">
          <div class="left">
            <el-image
              :src="src"
              fit="cover"
              style="vertical-align: bottom"
            ></el-image>
          </div>
          <div class="right" v-if="!regester">
            <strong>长丰数字草莓操作系统</strong>
            <el-form>
              <el-form-item>
                <el-input
                  type="text"
                  v-model="account"
                  placeholder="账号（手机号或用户名）"
                  prefix-icon="el-icon-user"
                  clearable
                />
              </el-form-item>
              <el-form-item>
                <el-input
                  type="password"
                  v-model="password"
                  placeholder="请输入密码"
                  prefix-icon="el-icon-lock"
                  show-password
                />
              </el-form-item>
              <el-form-item>
                <el-button
                  native-type="submit"
                  @click="loginSubmit"
                  type="success"
                  style="width: 100%"
                >
                  登录
                </el-button>
              </el-form-item>
              <!--              <div class="regester">-->
              <!--                <el-button type="text" style="color: gray;font-size: 14px" @click="regesterBtn">注册</el-button>-->
              <!--              </div>-->
            </el-form>
          </div>
          <div v-if="regester" class="regesterBox">
            <div
              style="
                display: flex;
                flex-wrap: nowrap;
                justify-content: space-between;
                vertical-align: middle;
              "
            >
              <el-button
                type="text"
                style="color: gray; font-size: 14px"
                @click="back"
              >
                返回登录
              </el-button>
            </div>
            <el-form
              label-position="top"
              label-width="80px"
              :model="regesterForm"
            >
              <el-form-item label="姓名">
                <el-input v-model="regesterForm.name" size="mini"></el-input>
              </el-form-item>
              <el-form-item label="手机号码">
                <el-input v-model="regesterForm.phone"></el-input>
              </el-form-item>
              <el-form-item label="密码">
                <el-input
                  type="password"
                  v-model="regesterForm.password"
                ></el-input>
              </el-form-item>
              <el-form-item label="确认密码">
                <el-input
                  type="password"
                  v-model="regesterForm.confirmPassword"
                ></el-input>
              </el-form-item>
              <el-form-item v-show="false">
                <el-button type="primary">注册</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { login, loginByToken } from '@/api/login.js'
import localToken from '@/api/local-token.js'
export default {
  name: 'Login',
  data() {
    return {
      account: undefined,
      password: undefined,
      src: require('./left-img.jpg'),
      regester: false,
      regesterForm: {
        phone: '',
        name: '',
        password: '',
        confirmPassword: '',
        memo: '',
      },
    }
  },
  mounted() {
    // 如果有本地token，先尝试利用本地token直接登录，跳过登录页面
    if (localToken.exists()) {
      loginByToken().then((resp) => {
        const personId = resp.data
        if (personId >= 0) {
          // 返回值不小于0的话，表示token直通成功，可以直接按登录过处理
          this.handleLoginPass(personId)
        }
      })
    }
  },
  methods: {
    back() {
      this.regester = false
    },
    regesterBtn() {
      this.regester = true
    },
    loginSubmit() {
      console.log('点击登录')
      login(this.account, this.password).then((resp) => {
        const code = resp.code
        switch (code) {
          case 20000:
            // 登录验证通过。
            const personId = resp.data
            this.handleLoginPass(personId)
            break
          default:
            console.log('登录错误')
            break
        }
      })
    },
    /**
     * 处理登录成功。有两个路径会调用此方法， 一个是正常登录，另一个是根据本地token直接登录，所以声明为独立的方法
     */
    handleLoginPass(personId) {
      this.$store.commit('userId', personId)
      this.$router.push('/profile')
    },
  },
}
</script>


<style scoped>
.el-card__body {
  padding: 0px !important;
}
.bg {
  width: 100%;
  height: 100%;
  position: absolute;
  background-image: url('./login-bg.jpg');
  background-size: 100% auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.content {
  width: 900px;
  height: 450px;
  display: flex;
}

.left {
  display: flex;
}
.regesterBox {
  width: 450px;
  padding: 30px 70px;
}
.right {
  width: 450px;
  padding: 70px;
}
.right strong {
  text-align: center;
  display: block;
  margin-bottom: 30px;
  font-size: 20px;
}
.regester {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue